import { acceptCourseTerms, type CourseRequirements, getCourseRequirements } from './credits-api'

type ConsentHandler = (requirements: CourseRequirements) => Promise<boolean>
let handler: ConsentHandler | undefined
export function registerCourseConsentHandler(next: ConsentHandler) {
  handler = next
  return () => {
    if (handler === next) handler = undefined
  }
}
export async function ensureCourseConsent(input: { sessionId?: string; courseId?: string }) {
  const requirements = await getCourseRequirements(input)
  if (!requirements.is_approved) throw new Error('COURSE_APPROVAL_REQUIRED')
  if (requirements.terms_accepted || !requirements.terms_required || !requirements.terms_version_id) return
  if (!handler || !await handler(requirements)) throw new Error('COURSE_TERMS_REQUIRED')
  await acceptCourseTerms(requirements.course_id, requirements.terms_version_id)
}
